import React from 'react';
import PropTypes from 'prop-types';
import { st, classes } from './Cell.st.css';

import { AnalyticsLayoutCellProps } from '../AnalyticsLayout.types';

/** Cell */
class Cell extends React.PureComponent<AnalyticsLayoutCellProps> {
  static defaultProps = {
    disableHighlight: false,
    children: null,
  };

  static displayName = 'Cell';

  static propTypes = {
    dataHook: PropTypes.string,
    disableHighlight: PropTypes.bool,
    children: PropTypes.any.isRequired,
  };

  state = { isHovered: false };

  _setHover(isHovered: boolean) {
    this.setState({ isHovered });
  }

  render() {
    const { dataHook, children, disableHighlight } = this.props;
    const { isHovered } = this.state;

    return (
      <div
        data-hook={dataHook}
        className={st(classes.root, {
          highlight: !disableHighlight && isHovered,
        })}
        onMouseEnter={() => this._setHover(true)}
        onMouseLeave={() => this._setHover(false)}
      >
        {children}
      </div>
    );
  }
}

export default Cell;
